import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axiosInstance";

export interface RoleAssignmentState {
  data: any[];
  status: boolean;
  error: string | null;
  count: number;
  skip: number;
  limit: number;
  accessStatus: string;
}

const initialState: RoleAssignmentState = {
  data: [],
  status: false,
  error: null,
  count: 0,
  skip: 1,
  limit: 25,
  accessStatus: "",
};

// Thunk to fetch role assignment requests
export const fetchArchivedRoleAssignmentRequests = createAsyncThunk(
  "roleArchiveAssignmentRequests/fetchData",
  async (params: { skip: number; limit: number; accessStatus?: string }) => {
    const response = await axiosInstance.get(
      `/request/archieve/data/myrequest?page_no=${params.skip}&page_size=${params.limit}`,
    );
    return response.data;
  },
);

const roleArchivedAssignmentRequestsSlice = createSlice({
  name: "roleArchivedAssignmentRequests",
  initialState,
  reducers: {
    setSkip: (state, action: PayloadAction<number>) => {
      state.skip = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setLoadStatus: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload;
    },
    resetData: (state) => {
      state.data = [];
      state.skip = 1;
      state.count = 0;
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchivedRoleAssignmentRequests.pending, (state) => {
        state.status = true;
      })
      .addCase(
        fetchArchivedRoleAssignmentRequests.fulfilled,
        (state, action) => {
          state.status = false;
          state.data = action.payload.data; // Assuming result contains data
          state.count = Number.isNaN(
            Number(action.payload?.data[0]?.full_count),
          )
            ? 0
            : Number(action.payload?.data[0]?.full_count);
        },
      )
      .addCase(
        fetchArchivedRoleAssignmentRequests.rejected,
        (state, action) => {
          state.status = false;
          state.error = action.error.message || "Failed to fetch data";
        },
      );
  },
});

export const { setSkip, setLimit, setLoadStatus, resetData } =
  roleArchivedAssignmentRequestsSlice.actions;
export default roleArchivedAssignmentRequestsSlice.reducer;
